import React from 'react'
import { Router } from 'react-router-dom'
import routes, { renderRoutes } from './routes';
import { createBrowserHistory } from 'history';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import { Toaster } from 'react-hot-toast'

const App = () => {

  const history = createBrowserHistory({});

  return (
      <Router history={history}>
        <AuthProvider>
          {renderRoutes(routes)}
          <Toaster position={"top-right"} toastOptions={{ className: 'react-hot-toast' }} />
        </AuthProvider>
      </Router>
  )
}

export default App
